export default __webpack_public_path__ + "static/media/Jennifer 9781408325100.7b13908e.jpg";